<template>
  <div>
      <my-navbar></my-navbar>
      <div class="my-content">
          <page-breadcrumb></page-breadcrumb>
          <!-- <transition name="fade"> -->
            <router-view></router-view>
          <!-- </transition> -->
      </div>
      <my-footer></my-footer>
  </div>
</template>

<script>
import myNavbar  from '../layout/navbar.vue'
import myFooter from '../layout/footer.vue'
import pageBreadcrumb from './elements/pageBreadcrumb.vue'

export default {
    components : { myNavbar,myFooter,pageBreadcrumb },
    data(){
        return{
            
            
        }
    },
    created(){
        
    },
    methods:{
        
    }
}
</script>

<style>
.nav-link{
    color: white !important;
}
.my-nav-link{
    text-decoration: underline  !important;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>